import React from "react"

export const BoardItem = ({ image, designation, batch, name }) => {
    return (
        <div className="founder-item mx-2">
            <div className="flex justify-center">
                <img src={image} className="rounded-full w-4/5" alt={name} />
            </div>
            <div className="text-center mt-2 ">
                <h1 className="font-bold text-3xl">{designation}</h1>
                <h3 className="text-2xl">{name}</h3>
                <h3 className="font-bold text-2xl">(Batch of {batch})</h3>
            </div>
        </div>
    )
}
